var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderReceipt',{attrs:{"header":"การเพิ่มสินค้าเข้าคลัง","img_header":_vm.header_image,"link_back":"stock/storage/mainstorage"}}),_c('AddProduct_ToStock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }